import { DIRECTIONS } from "@repo/ui/constants/directions";
import type { Passenger } from "@repo/ui/types/manageBooking";

export function isSsrIncluded(
  passengers?: Passenger[],
  passengerKey?: string,
  ssrCode?: string,
  direction?: string,
): boolean {
  // 1. Find passenger by key
  const passenger = passengers?.find((p) => p.passengerKey === passengerKey);
  if (!passenger) return false;

  // 2. Select the correct journey SSRs
  const journeySsrs =
    direction === DIRECTIONS.OUTBOUND
      ? passenger.outboundJourneySSRs
      : passenger.inboundJourneySSRs;

  if (!journeySsrs) return false;

  // 3. Check if SSR code exists in either bundle or individual SSRs
  const allSsrs = [...(journeySsrs.bundleSsrs || []), ...(journeySsrs.individualSsrs || [])];

  return allSsrs.some((ssr) => ssr.code === ssrCode);
}
